export const SET_REVIEWS = "SET_REVIEWS";
export const RESET_REVIEWS = "RESET_REVIEWS";
export const SET_SPECIFIC_REVIEW = "SET_SPECIFIC_REVIEW";
export const RESET_SPECIFIC_REVIEW = "RESET_SPECIFIC_REVIEW";
export const SET_REVIEW_LOADING = "SET_REVIEW_LOADING";
export const RESET_REVIEW_LOADING = "RESET_REVIEW_LOADING";